import appStore from 'store'
import api from './api'
import {
  REGISTER_FORM,
  USER_STATUS,
  BANK_AUTH_STATUS,
  ID_NO_STATUS,
  EMAIL_SECURITY_STATUS,
  PHONE_SECURITY_STATUS,
  GOOGLE_SECURITY_STATUS,
  USER_VALUNTEER_STATUS,
  USER_BLOCKING_STATUS,
  QUERY_TYPE,
  PAGINATION,
} from './constants'

const store = {
  namespaced: true,
  state: {
    userList: [],
    totalCount: 0,
    pagination: PAGINATION,
    queryTypeList: QUERY_TYPE,
    queryType: QUERY_TYPE[0].value,
    userinfoDetail: {},
    userinfoDetailDialogVisible: false,
    dialogVisible: false,
    createVisible: false,
    notedetail: {},
    countryCodeList: [],
    accountVisible: false,
    showAccountInfo: {},
    delVisible: false,
  },
  getters: {
    userList: (state) =>
      state.userList.map((item) => {
        return {
          ...item,
          __registerFrom: REGISTER_FORM[item.registerFrom],
          __userStatus: USER_STATUS[item.userStatus],
          __bankAuthStatus: BANK_AUTH_STATUS[item.bankAuthStatus],
          __idNoStatus: ID_NO_STATUS[item.idNoStatus || 0],
          __emailSecurityStatus:
            EMAIL_SECURITY_STATUS[item.emailSecurityStatus || 0],
          __phoneSecurityStatus:
            PHONE_SECURITY_STATUS[item.phoneSecurityStatus || 0],
          __googleSecurityStatus:
            GOOGLE_SECURITY_STATUS[item.googleSecurityStatus || 0],
          __userVolunteerStatus:
            USER_VALUNTEER_STATUS[item.userVolunteerStatus || 0],
          __userBlockingStatus: USER_BLOCKING_STATUS[item.userStatus || 0],
        }
      }),
  },
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list.slice()
      state.totalCount = payload.totalCount
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setQueryType(state, payload) {
      state.queryType = payload
    },
    setUserinfoDetailDialogVisible(state, payload) {
      state.userinfoDetailDialogVisible = payload
    },
    setdialogVisible(state, payload) {
      state.dialogVisible = payload
    },
    setnodedetail(state, payload) {
      state.notedetail = payload
    },
    setUserinfoDetail(state, payload) {
      state.userinfoDetail = payload
    },
    setCountryCodeList(state, payload) {
      state.countryCodeList = payload
    },
    setCreateVisible(state, payload) {
      state.createVisible = payload
    },
    setAccountVisible(state, payload) {
      console.log(payload, '=payload')
      state.accountVisible = payload
    },
    setShowAccountInfo(state, payload) {
      state.showAccountInfo = payload
    },
    setDelVisible(state, payload) {
      state.delVisible = payload
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      commit('setQueryType', query.queryType)

      api.getUserList(query).then(({ data }) => {
        commit('setUserList', data)
      })
    },
    updateVolunteer({ commit }, data) {
      // eslint-disable-line
      return new Promise((resolve) => {
        api.updateVolunteer(data).then((res) => {
          resolve(res)
        })
      })
    },
    updateBlocking({ commit }, data) {
      // eslint-disable-line
      return new Promise((resolve) => {
        api.updateBlocking(data).then((res) => {
          resolve(res)
        })
      })
    },
    cancelGoogle(context, data) {
      return new Promise((resolve) => {
        api.cancelGoogle(data).then((res) => {
          resolve(res)
        })
      })
    },
    coutryCode({ commit }) {
      return api.coutryCode().then(({ data }) => {
        commit('setCountryCodeList', data)
      })
    },
    updatInfo(content, data) {
      return api.updatInfo(data)
    },
    updateUserType(content, data) {
      return api.updateUserType(data)
    },
    updateDividendStatus(context, data) {
      return api.updateDividendStatus(data)
    },
    setNode(content, data) {
      return api.setNode(data)
    },
    resetPassword(content, data) {
      return api.resetPassword(data)
    },
    updateMark(content, data) {
      return api.updateMark(data)
    },
    addUser(commit, { email, pwd, vipLevel }) {
      return api.addUser({ email, pwd, vipLevel }).then((res) => {
        return res
      })
    },
    getMockProfitBonusLevelOptions() {
      return api.getMockProfitBonusLevelOptions()
    },
    updateMockProfitBonusLevel(content, data) {
      return api.updateMockProfitBonusLevel(data)
    },
    updateMockVipLevel(content, data) {
      return api.updateMockVipLevel(data)
    },
    showAccount({ commit }, { userId, googleCode }) {
      return api.showAccount({ userId, googleCode }).then((res) => {
        if (res.code == 0) {
          commit('setShowAccountInfo', res.data)
        }
        return res
      })
    },
    checkGoogle(content, data) {
      return api.checkGoogle(data)
    },
    delPositionId({ commit }, { positionId }) {
      api.delPositionId(positionId).then((res) => {
        if (res.code == 0) {
          commit('setSymbolList', res.data)
        }
      })
    },
  },
}

appStore.registerModule('userOldSimulation', store)
